import { Button } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { FormattedDate } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './RepayEarly.module.css';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';
import { REQUEST_CHANGE_ROUTER } from '../../../../../iwRouter/IwRouter.actions';
import { getNextRepayment } from '../../../repaymentScheduleSelectors';
import { Account } from '../../Dashboard.types';

const mapStateToProps = (
    state: RootState,
    { account }: { account: Account }
) => {
    const nextRepayment = getNextRepayment(state, account);

    return {
        nextRepaymentAmount: nextRepayment.total,
        nextRepaymentDate: nextRepayment.date,
        accountId: account.account_id
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToEarlyRepayment: (accountId: string) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/repayment/choose-amount/',
                search: `?accountId=${accountId}`
            }
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const Repay = ({
    nextRepaymentAmount,
    nextRepaymentDate,
    goToEarlyRepayment,
    accountId
}: PropsFromRedux) => {
    if (!accountId) return null;

    const isRepaymentToday =
        new Date(nextRepaymentDate).toDateString() ===
        new Date().toDateString();

    const buttonText = isRepaymentToday
        ? 'Make a payment'
        : 'Make an early payment';

    return (
        <>
            <div
                data-testid="repay-early-explanation"
                className={styles.explanation}
            >
                Your next automatic payment of{' '}
                <FormattedCurrency
                    className={styles.explanationAmount}
                    value={nextRepaymentAmount}
                />{' '}
                will be on{' '}
                {<FormattedDate value={new Date(nextRepaymentDate)} />}. You can
                make a payment here any time with no extra fees.
            </div>

            <Button
                data-testid="repay-early-cta"
                className={styles.cta}
                onClick={() => goToEarlyRepayment(accountId)}
            >
                {buttonText}
            </Button>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Repay);
